<template>
  <TextField
    id="cbord-auth-url"
    name="keystore.auth_url"
    :label="t('sites.singleSite.financialConfig.mealPlans.form.cbordAuthURL')"
    :placeholder="t('sites.singleSite.financialConfig.mealPlans.form.cbordAuthURLPlaceholder')"
    :required="editMealPlan"
    :disabled="!editMealPlan"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../routes';

// Set localization
const { t } = useI18n();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);
</script>
